// function updateColorVariantLabel() {
//   const selectedSpan = document.querySelector('#selected-option-0');
//   if (!selectedSpan) return;

//   const checkedRadio = document.querySelector('input[type="radio"][name^="Color"]:checked');
//   if (!checkedRadio) return;

//   const label = document.querySelector(`label[for="${checkedRadio.id}"]`);
//   if (!label) return;

//   const visuallyHiddenSpan = label.querySelector('.visually-hidden');
//   if (!visuallyHiddenSpan) return;

//   selectedSpan.textContent = visuallyHiddenSpan.textContent.trim();
// }

// // Setup listener
// document.addEventListener('DOMContentLoaded', function () {
//   updateColorVariantLabel(); // Initial load

//   // Watch for direct radio button changes
//   const radios = document.querySelectorAll('input[type="radio"][name^="Color"]');
//   radios.forEach(radio => {
//     radio.addEventListener('change', () => {
//       // Delay to let Shopify finish updating the DOM
//       setTimeout(updateColorVariantLabel, 100);
//     });
//   });

//   // ALSO watch Shopify variant update events
//   const variantSelects = document.querySelectorAll('variant-selects');
//   variantSelects.forEach(el => {
//     el.addEventListener('variant:change', () => {
//       // Run after Shopify updates the DOM
//       setTimeout(updateColorVariantLabel, 100);
//     });
//   });
// });
// function openPopup() {
//   const $popup = $('.cc-popup');

//   // Save previously focused element (optional)
//   const previouslyActive = document.activeElement;

//   $popup.addClass('is-visible');

//   // Focus first focusable element inside the popup (accessibility)
//   const $focusable = $popup.find('[tabindex], a, button, input, textarea, select').filter(':visible').first();
//   if ($focusable.length) {
//     $focusable.focus();
//   } else {
//     $popup.attr('tabindex', '-1').focus();
//   }

//   // Optional: prevent body scroll
//   if ($popup.data('freeze-scroll') === true) {
//     $('body').addClass('no-scroll');
//   }

//   // Escape key to close popup
//   $(window).on('keydown.popupEscape', function (e) {
//     if (e.key === 'Escape') {
//       closePopup();
//     }
//   });
// }

// function closePopup() {
//   const $popup = $('.cc-popup');

//   $popup.removeClass('is-visible');

//   // Allow scroll again
//   $('body').removeClass('no-scroll');

//   // Remove Escape handler
//   $(window).off('keydown.popupEscape');
// }

// $(window).on('load', function () {
//   openPopup();
// });


  document.addEventListener('DOMContentLoaded', function () {
    const mainSection = document.querySelector('.new-main-product');
    const productForm = mainSection?.querySelector('product-form');
    const wishlistBtn = document.querySelector('.koh-wishlist-btn[data-product-id]');

    if (mainSection && productForm && wishlistBtn) {
      const wishlistWrapper = wishlistBtn.closest('.shopify-block');
      if (wishlistWrapper) {
        productForm.insertAdjacentElement('afterend', wishlistWrapper);
      }
    }
  });

